<template lang="pug">
masked-input(
  v-bind="attrs"
  v-on="$listeners"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(
      :name="name"
      v-bind="data"
    )
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
</template>

<script>
import MaskedInput from '@/components/user-redesign/inputs/MaskedInput.vue';

const COUNTY_CODE = '7';
const MASK = `+${COUNTY_CODE} (###) ###-####`;

export default {
  name: 'PhoneInput',
  components: {
    MaskedInput,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    attrs() {
      const { value, ...rest } = this.$attrs;
      const inputValue = (value || '').startsWith(COUNTY_CODE) ? value.slice(1) : value;

      return {
        label: 'Номер телефона',
        mask: MASK,
        value: inputValue,
        normalize: this.normalize,
        ...rest,
      };
    },
  },
  watch: {},
  methods: {
    normalize(value) {
      return value?.replace(/\D/g, '') || '';
    },
  },
};
</script>
